import React from "react";
import { useTranslation, } from "react-i18next";
import SelectItem from "../SelectItem/SelectItem";
import { Box, } from "@mui/material";

// icons
import russianIcon from "assets/icons/Russian.svg";
import kyrIcon from "assets/icons/Kyrgyz.svg";
import englishIcon from "assets/icons/English.svg";

import classes from "../../header.module.scss";

const LanguageMenu = () => {
  const { i18n, } = useTranslation();

  const langArr =
  [
    { id: "ky", title: "Кыр", img: kyrIcon, },
    { id: "ru", title: "Рус", img: russianIcon, },
    { id: "en", title: "Eng", img: englishIcon, },
  ];

  const lang = i18n.language || "ky";
  const selectedLang = langArr.find(item => item.id === lang) || langArr[0];

  return (
    <Box className={classes.burgerMenu}>
      <SelectItem selected={selectedLang.title} menuContent={langArr}/>
    </Box>
  );
};

export default LanguageMenu;
